export const GAUGE_RANGE_FONT_SIZES = [12, 13, 14, 15, 16, 17, 18];
export const GAUGE_TOTAL_FONT_SIZES = [30, 35, 40, 45, 50, 60, 70];
